import router from '@/router';
import axios from 'axios';

export default {
  login(context, data) {
    context.commit('SET_LOADING', true);
    axios
      .post(process.env.VUE_APP_API_URL + '/auth', {
        username: data.username,
        password: data.password
      })
      .then(result => {
        console.log('Login result:', result.data);

        // Store accessToken and refreshToken in sessionStorage
        sessionStorage.setItem('accessToken', result.data.data.idToken);
        sessionStorage.setItem('refreshToken', result.data.data.refreshToken);
        sessionStorage.setItem('username', data.username);

        // this.$store.dispatch('auth/setMemberInGroups');
        context.dispatch('setUserDetails', {
          username: data.username
        });

        context.commit('SET_LOADING', false);
        router.push(router.currentRoute.query.redirect || '/');
      })
      .catch(err => {
        console.error('Login.vue - Login error:', err.response);
        if (err.response.status === 401) {
          this.dispatch('errors/update', {
            state: true,
            message: 'Wrong username / password combination'
          });
        }
        context.commit('SET_LOADING', false);
      });
  },

  clearUserData(context) {
    context.commit('SET_MEMBER_IN_GROUPS', null);
    context.commit('SET_USERNAME', null);
  },

  setMemberInGroups(context) {
    if (sessionStorage.getItem('accessToken')) {
      const token = sessionStorage.getItem('accessToken');
      const base64url = token.split('.')[1];
      const decodedValue = JSON.parse(window.atob(base64url));
      // console.log(d[store.js] - ecodedValue)
      context.commit('SET_MEMBER_IN_GROUPS', decodedValue['cognito:groups']);
    } else {
      router.push({ path: '/login' });
    }
  },

  setUserDetails(context, userDetails) {
    context.commit('SET_USERNAME', userDetails.username);
  },

  refreshToken() {
    console.log('[store.js] - refreshToken triggered');
    const refreshToken = sessionStorage.getItem('refreshToken');
    const username = sessionStorage.getItem('username');
    axios
      .post(process.env.VUE_APP_API_URL + '/auth/token', {
        refresh_token: refreshToken,
        username: username
      })
      .then(result => {
        console.log('[store.js] - Successfully refreshed token');
        sessionStorage.setItem('accessToken', result.data.data.access_token);
      })
      .catch(err => {
        console.log('[store.js] - Error trying to refresh token', err);
        if (router.currentRoute.name !== 'Login')
          router.push({ path: '/login' });
      });
  }
};
